module.exports = __webpack_public_path__ + "media/images/podcast-2-ea7b00c80cf681bdc31b033ae8cae9ad.jpg";